"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _mui = require("tss-react/mui");
var _reactCircleFlags = require("react-circle-flags");
var _reactI18next = require("react-i18next");
var _Paper = _interopRequireDefault(require("@mui/material/Paper"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _InputAdornment = _interopRequireDefault(require("@mui/material/InputAdornment"));
var _Delete = _interopRequireDefault(require("@mui/icons-material/Delete"));
var _Input = _interopRequireDefault(require("../Input"));
var _excluded = ["languages", "name", "label", "hasBackground", "fullWidth", "onDelete", "handleChange", "value", "errors"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _mui.makeStyles)()(function (theme, _params, classes) {
  return {
    root: _defineProperty({
      padding: theme.spacing(2, 1.3),
      display: 'inline-flex',
      flexShrink: 0,
      flexDirection: 'column',
      position: 'relative',
      width: 206,
      borderRadius: 10,
      backgroundColor: theme.palette.background["default"],
      boxShadow: theme.customShadows.small
    }, "&:hover .".concat(classes.deleteButton), {
      display: 'block'
    }),
    fullWidth: {
      width: '100%',
      marginRight: 0
    },
    deleteButton: {
      display: 'none',
      alignSelf: 'flex-end',
      position: 'absolute',
      top: theme.spacing(1),
      color: theme.palette.red.main
    },
    fieldSet: {
      all: 'unset',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-evenly'
    },
    legend: {
      marginBottom: theme.spacing(-1),
      color: theme.palette.darkGrey.light,
      fontSize: 12
    },
    input: {
      marginTop: theme.spacing(2)
    },
    hasBackground: {
      backgroundColor: theme.palette.lightGrey.main,
      boxShadow: 'none'
    }
  };
});
var MultilanguageFieldInputs = function MultilanguageFieldInputs(_ref) {
  var languages = _ref.languages,
    name = _ref.name,
    label = _ref.label,
    hasBackground = _ref.hasBackground,
    fullWidth = _ref.fullWidth,
    onDelete = _ref.onDelete,
    _handleChange = _ref.handleChange,
    value = _ref.value,
    errors = _ref.errors,
    other = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles(),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var _useTranslation = (0, _reactI18next.useTranslation)('multilanguageInputs'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
    className: cx(classes.root, hasBackground && classes.hasBackground, fullWidth && classes.fullWidth)
  }, onDelete && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    "aria-label": "delete",
    size: "small",
    className: classes.deleteButton,
    onClick: onDelete
  }, /*#__PURE__*/_react["default"].createElement(_Delete["default"], null)), /*#__PURE__*/_react["default"].createElement("fieldset", {
    className: classes.fieldSet
  }, /*#__PURE__*/_react["default"].createElement("legend", {
    className: classes.legend
  }, label), languages.map(function (_ref2) {
    var _errors$locale;
    var locale = _ref2.locale,
      code = _ref2.code,
      languageLabel = _ref2.label;
    return /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({
      value: (value === null || value === void 0 ? void 0 : value[locale]) || '',
      key: "".concat(name, "-").concat(locale),
      id: "".concat(name, "-").concat(locale),
      className: classes.input,
      placeholder: "".concat(label, " ").concat(t('in'), " ").concat(languageLabel),
      "aria-label": "".concat(label, " ").concat(t('in'), " ").concat(languageLabel),
      classes: {
        root: hasBackground && classes.hasBackground
      },
      handleChange: function handleChange(val) {
        return _handleChange(_objectSpread(_objectSpread({}, value), {}, _defineProperty({}, locale, val)));
      },
      error: errors === null || errors === void 0 ? void 0 : (_errors$locale = errors[locale]) === null || _errors$locale === void 0 ? void 0 : _errors$locale.message
    }, other, {
      startAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
        position: "start"
      }, /*#__PURE__*/_react["default"].createElement(_reactCircleFlags.CircleFlag, {
        height: 20,
        countryCode: code
      }))
    }));
  })));
};
MultilanguageFieldInputs.propTypes = {
  value: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  errors: _propTypes["default"].objectOf(_propTypes["default"].objectOf(_propTypes["default"].string)),
  languages: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    locale: _propTypes["default"].string,
    code: _propTypes["default"].string,
    label: _propTypes["default"].string
  })).isRequired,
  name: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  handleChange: _propTypes["default"].func.isRequired,
  onDelete: _propTypes["default"].func,
  hasBackground: _propTypes["default"].bool,
  fullWidth: _propTypes["default"].bool
};
MultilanguageFieldInputs.defaultProps = {
  errors: {},
  hasBackground: false,
  fullWidth: false,
  onDelete: undefined
};
var _default = MultilanguageFieldInputs;
exports["default"] = _default;